import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { IAddToCartPriceJson } from 'JS/services/ProductService';
import { stringIsNullOrWhiteSpace } from 'JS/helpers/functions';


export default /*#__PURE__*/_defineComponent({
  __name: 'CartSidebarPrice',
  props: {
    priceModel: null,
    isQuickAdd: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
	priceModel: IAddToCartPriceJson;
	isQuickAdd?: boolean;
}



const discountMessage = computed(() => {
	if (props.priceModel.isSpecialOfferPrice) return 'Special Offer';
	else if (props.priceModel.isRewardsMemberPrice) return 'Rewards Member Price';
	else if (hasPricePromoText.value) return props.priceModel.price.pricePromoText;
	else if (props.priceModel.price.pricePrefixText && props.priceModel.price.originalPrice) return props.priceModel.price.pricePrefixText;
	else return '';
});

const discountMessageSecondary = computed(() => {
	// if something is both on sale and has a promo offer we don't want the sale-specific "$x off" message to appear next to "Special Offer"
	if (props.priceModel.isSpecialOfferPrice || props.priceModel.isRewardsMemberPrice) return '';
	else if (props.priceModel.price.isOnSale && props.priceModel.price.priceSavingsTextShortFormat) return `${props.priceModel.price.priceSavingsTextShortFormat} off`;
	else return '';
});

const discountClasses = computed(() => {
	let classes = 'price-top grey';
	if (props.priceModel.isSpecialOfferPrice) classes += ' special-offer';
	else if (props.priceModel.isRewardsMemberPrice) classes += ' rewards-price';
	else if (
		props.priceModel.price.isOnSale 
		|| props.priceModel.price.isClearance 
		|| props.priceModel.price.isBelowMAP) classes += ' on-sale';
	return classes;
});

const strikeThroughWasPrice = computed(() => {
	if (props.isQuickAdd) {
		return props.priceModel.price.strikeThroughWasPrice; //follow PDP rules for product recommendations
	} else {
		return true; //always strike was price for product in cart
	}
});

const hasPricePromoText = computed(() => !stringIsNullOrWhiteSpace(props.priceModel.price.pricePromoText)
	&& props.priceModel.price.pricePromoText.toLowerCase().indexOf('today') < 0);

return { __sfc: true,props, discountMessage, discountMessageSecondary, discountClasses, strikeThroughWasPrice, hasPricePromoText }
}

})